// The 14 allergens that must be declared under EU Regulation 1169/2011.
// Keys are stable identifiers stored on products; labels are localised.
export const ALLERGENS = [
  { key: "gluten", emoji: "🌾", sv: "Gluten", en: "Gluten" },
  { key: "crustaceans", emoji: "🦐", sv: "Kräftdjur", en: "Crustaceans" },
  { key: "eggs", emoji: "🥚", sv: "Ägg", en: "Eggs" },
  { key: "fish", emoji: "🐟", sv: "Fisk", en: "Fish" },
  { key: "peanuts", emoji: "🥜", sv: "Jordnötter", en: "Peanuts" },
  { key: "soybeans", emoji: "🌱", sv: "Soja", en: "Soybeans" },
  { key: "milk", emoji: "🥛", sv: "Mjölk (laktos)", en: "Milk (lactose)" },
  { key: "nuts", emoji: "🌰", sv: "Nötter", en: "Tree nuts" },
  { key: "celery", emoji: "🥬", sv: "Selleri", en: "Celery" },
  { key: "mustard", emoji: "🌭", sv: "Senap", en: "Mustard" },
  { key: "sesame", emoji: "◦", sv: "Sesam", en: "Sesame" },
  { key: "sulphites", emoji: "🍷", sv: "Sulfit", en: "Sulphites" },
  { key: "lupin", emoji: "🌸", sv: "Lupin", en: "Lupin" },
  { key: "molluscs", emoji: "🦪", sv: "Blötdjur", en: "Molluscs" },
];

export const ALLERGEN_KEYS = ALLERGENS.map((a) => a.key);

const BY_KEY = Object.fromEntries(ALLERGENS.map((a) => [a.key, a]));

export function allergenLabel(key, lang = "sv") {
  const a = BY_KEY[key];
  if (!a) return key;
  return a[lang] || a.sv;
}

export function allergenEmoji(key) {
  return BY_KEY[key]?.emoji || "";
}
